import { Attachment, BaseModel, User } from '../api-v2'

export enum MediaType {
  SOUND = 'sound',
  FILE = 'file'
}

export enum SoundMediaType {
  ONESHOT = 'one-shot',
  LOOP = 'loop',
  STEM = 'stem'
}

export interface SoundMediaMetadata {
  media?: Media
  bpm: number
  key: number
  tags: string[]
  type: SoundMediaType
  durationMs: number
  soundFile?: Attachment
  lossySoundFile?: Attachment | null
}

export interface FileMediaMetadata {
  file?: Attachment
}

export type MediaMetadata = SoundMediaMetadata | FileMediaMetadata

export interface BaseMedia extends BaseModel {
  title: string
  description?: string
  isPreview: boolean
  userId: number | null
  user?: User
  parentId: number | null
  mediaCollectionId: number | null
}

export interface SoundMedia extends BaseMedia {
  mediaType: MediaType.SOUND
  metadata: SoundMediaMetadata
  subMedia: SoundMedia[]
}

export interface FileMedia extends BaseMedia {
  mediaType: MediaType.FILE
  metadata: FileMediaMetadata
}

export type Media = SoundMedia | FileMedia
